<template>
    <div>
        <my-form
            class="mobileInputBox"
            v-model="form"
            autocomplete="off"
            label-width="0"
            @submit="submitHandler"
            >
            <el-form-item
                prop="mobile"
                :rules="newRule('手机号', 'required', 'mobile')"
                >
                <el-input
                    class="login-input"
                    v-model="form.mobile"
                    clearable
                    autocomplete="off"
                    :placeholder="`请输入手机号`"
                ></el-input>
            </el-form-item>

            <el-form-item
              prop="imgCode"
              :rules="newRule('图形验证码', 'required')"

            >
              <el-input
                class="login-input"
                v-model="form.imgCode"
                clearable
                autocomplete="off"
                placeholder="请输入图形验证码">
              </el-input>
              <div v-loading="!isImageLoaded" style="position: absolute;right: 0;top: -27px;">
                <img @click="getImageSrc" :src="imageSrc" alt="图形验证码" @load="handleImageLoad"/>
              </div>
            </el-form-item>

            <el-form-item
                prop="yzm"
                :rules="newRule('验证码', 'required')"
                >
                <input-yzm
                    class="login-input"
                    :mobile="form.mobile"
                    :imgCode="form.imgCode"
                    :uuid="uuid"
                    v-model="form.yzm"
                    :placeholder="`请输入验证码`"
                    type="text"
                ></input-yzm>
            </el-form-item>

            <template slot="btn" slot-scope="scope">
                <el-button
                    type="primary"
                    class="btn-login"
                    @click="scope.submitHandler"
                    >
                    {{text}}
                </el-button>

                <div class="info">
                    登录代表您已同意{{CONFIG_PROJECT.title}}<span class="curp czhu" @click="getProtocol">服务协议和隐私政策</span>
                </div>
            </template>
        </my-form>
    </div>
</template>

<script>
import CONFIG_PROJECT from '@config/project';

import InputYzm from '@components/sys/input-yzm'

export default {
    components: {
        InputYzm,
    },
    data() {
        return {
            form: {
                mobile: '',
                yzm: '',
                imgCode: '',
            },
            CONFIG_PROJECT,
            loginType: 'scanQRCode',
            imageSrc: '',
            uuid: '',
            isImageLoaded: false
        }
    },
    props:{
        openID:{
            type:String,
            default:''
        },
        text:{
            type:String,
            default:'注册 / 登录'
        }
    },
    methods: {
        submitHandler() {
            if(this.openID){
                this.form.wechatId = this.openID
            }
            this.$emit('submitHandler', this.form)
        },
        getProtocol(){
            this.$emit("getProtocol")
        },
        getImageSrc(){
          this.isImageLoaded = false;
          this.$get('/web/bbs/img/captchaImage', data => {
            this.imageSrc = 'data:image/png;base64,'+data.imgVerify;
            this.uuid = data.uuid;
          });
        },
        handleImageLoad() {
          this.isImageLoaded = true;
        },
    },
    mounted() {
      this.getImageSrc();
    }
}
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .mobileInputBox {
        padding: 30px 20px;
    }

    .el-form-item--small.el-form-item{
        margin-bottom: 40px;
    }

    .info {
        padding-top: 10px;
    }

    .login-input{
        border-bottom: 1px solid #e0e4e6;

        ::v-deep{
            .el-input__inner {
                background: transparent;
                border: none;
                border-radius: 0;
                padding: 0;
            }

            .el-input-group__append{
                border: none;
                background: transparent;
                // &:hover{
                //     color: $primaryColor7;
                // }

                .btn-yzm{
                    padding: 9px 0;
                }
            }
        }
    }

    .btn-login{
        width:100%;
        font-size: 16px;
        padding: 15px;
    }
</style>
